import { useUsersStore } from '@/stores/users'

/**
 * Level 1 com own e sem mod_report.
 */
export function isSatisfactionOwnMode(user = null) {
    const u = user || useUsersStore().me
    if (!u || Number(u.level) !== 1) {
        return false
    }
    const permissions = u.permissions || []
    return permissions.includes('mod_report_satisfaction_own')
        && !permissions.includes('mod_report')
}

export function hasReportMenuAccess(user = null) {
    const u = user || useUsersStore().me
    if (!u) {
        return false
    }
    if (Number(u.level) >= 2) {
        return true
    }
    const permissions = u.permissions || []
    return permissions.includes('mod_report')
        || permissions.includes('mod_report_satisfaction_own')
}

export function reportsHomeRouteName(user = null) {
    return isSatisfactionOwnMode(user)
        ? 'reports.satisfactionSurvey.home'
        : 'reports.home'
}
